import React from 'react';

const Loading = () => {
  return (
    <div className={`d-flex justify-content-center`}>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <div class='spinner-grow txt-primary mx-1' role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
